// The onboarding layout only mounts brief/index (steps 1, 3, 4) and getting_started/index
// (new_package). Register just those two, so webpack bundles only what they import, rather
// than a require.context that pulls in every file under their folders.
var components = {
  './brief/index': require('components/brief/index'),
  './getting_started/index': require('components/getting_started/index')
};

// Stands in for require.context: react_ujs only calls it with "./<name>" and handles
// `export default` itself. Throwing on a miss keeps its fallback to window globals.
function componentRequireContext(path) {
  if (!components[path]) throw new Error('Cannot find module "' + path + '"');
  return components[path];
}

var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);



// WEBPACK FOOTER //
// ./app/javascript/packs/onboarding_components.js